/**
 * Dónde se baja la app de TBit Jobs: iOS en la App Store desde el 2026-11-01 y
 * Android en Google Play desde el 2026-11-04. Si alguna vuelve a ser null, su
 * botón dice «Próximamente» y no lleva a ninguna parte.
 */
export const APP_STORE_URL = 'https://apps.apple.com/app/id6829097799';
export const PLAY_STORE_URL: string | null = 'https://play.google.com/store/apps/details?id=com.tbit.jobs';
